module.exports = __webpack_public_path__ + "img/img_2.7083fc70.jpg";